import { render, staticRenderFns } from "./gps-config-settings.vue?vue&type=template&id=51bc0668&scoped=true&"
import script from "./gps-config-settings.vue?vue&type=script&lang=ts&"
export * from "./gps-config-settings.vue?vue&type=script&lang=ts&"
import style1 from "./gps-config-settings.vue?vue&type=style&index=1&id=51bc0668&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bc0668",
  null
  
)

export default component.exports